var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSubway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20956_2042)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C5 6 3 9 3 9L4 12V13C4 15.2091 5.79086 17 8 17H14C16.2091 17 18 15.2091 18 13V12L19 9C19 9 17 6 11 6ZM11 11C13.6121 11 15.7977 11.4264 17 11.7224V13C17 14.6569 15.6569 16 14 16H8C6.34315 16 5 14.6569 5 13V11.7224C6.20227 11.4264 8.38792 11 11 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#00A154"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7C5 5.34315 6.34315 4 8 4H14C15.6569 4 17 5.34315 17 7V14C17 15.1046 16.1046 16 15 16H14L14.6382 17.2764C14.8044 17.6088 14.5627 18 14.191 18H7.80902C7.43733 18 7.19558 17.6088 7.3618 17.2764L8 16H7C5.89543 16 5 15.1046 5 14V7ZM8 6C7.44772 6 7 6.44772 7 7V10H15V7C15 6.44772 14.5523 6 14 6H8ZM8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14ZM15 13C15 13.5523 14.5523 14 14 14C13.4477 14 13 13.5523 13 13C13 12.4477 13.4477 12 14 12C14.5523 12 15 12.4477 15 13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20956_2042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubway);
export default __webpack_public_path__ + "static/media/icon-subway.0a1676b9bd76c3b4a3f0cfa297e11d9e.svg";
export { ForwardRef as ReactComponent };